import type { ApiTypes, EditApiTypes } from '@hyundai/ng-common-lib';
import type { Identifiers } from '@hyundai/shared-lib/edit';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const actions = createActionGroup({
    source: 'edit',
    events: {
        'Enable Editmode': emptyProps(),
        'Disable Editmode': emptyProps(),

        'Initalize Edit Dialog': props<{ identifier: Identifiers }>(),
        'Open Dialog': emptyProps(),
        'Dialog close': emptyProps(),
        'Dialog save': emptyProps(),

        'Refresh Page': emptyProps(),
        'Refresh Content': props<{ identifier: Identifiers }>(),

        'Submit Text Edit': props<{ identifier: Identifiers; value: string }>(),
        'Submit Text Edit Success': emptyProps(),
        'Submit Text Edit Failure': props<{ error: string }>(),

        'Submit Bullet Edit': props<{ identifier: Identifiers; value: string }>(),
        'Submit Bullet Edit Success': emptyProps(),
        'Submit Bullet Edit Failure': props<{ error: string }>(),

        'Submit Image Upload': props<{ identifier: Identifiers; value: string }>(),
        'Submit Image Upload Success': emptyProps(),
        'Submit Image Upload Failure': props<{ error: string }>(),

        'Init About Us Teaser Edit': props<{ teasers: ApiTypes.AboutUsTeaser[] }>(),
        'Add new About Us Teaser': emptyProps(),
        'Update About Us Teaser': props<{ teaser: EditApiTypes.DraftAboutUsTeaser }>(),
        'Update About Us Teasers Order': props<{ previousIndex: number; currentIndex: number }>(),
        'Remove About Us Teaser': props<{ index: number }>(),
        'Save About Us Teasers': emptyProps(),
        'Save About Us Teasers Success': emptyProps(),
        'Save About Us Teasers Failure': props<{ error: string }>(),

        'Load Employees': emptyProps(),
        'Load Employees Success': props<{ employees: ApiTypes.EditEmployee[] }>(),
        'Load Employees Failure': props<{ error: string }>(),
        'Update Employee Order': props<{ previousIndex: number; currentIndex: number }>(),
        'Update Employee': props<{
            id: ApiTypes.EditEmployee['id'];
            index: number;
            employee: Partial<ApiTypes.EditEmployee>;
        }>(),

        'Save Employees': emptyProps(),
        'Save Employees Success': emptyProps(),
        'Save Employees Failure': props<{ error: string }>(),

        'Delete Employee': props<{ index: number }>(),

        'Submit Setting': props<{ identifier: Identifiers; value: string }>(),
        'Submit Setting Success': emptyProps(),
        'Submit Setting Failure': props<{ error: string }>(),

        'Load Dealer Campaigns': emptyProps(),
        'Load Dealer Campaigns Success': props<{ dealerCampaigns: ApiTypes.DealerCampaignEdit[] }>(),
        'Load Dealer Campaigns Failure': props<{ error: string }>(),

        'Load Dealer Campaign Detail': props<{ campaignId: number }>(),
        'Load Dealer Campaign Detail Success': props<{ campaign: ApiTypes.DealerCampaignEditDetail }>(),
        'Load Dealer Campaign Detail Failure': props<{ error: string }>(),

        'Upsert Dealer Campaign': props<{ campaign: ApiTypes.UpsertDealerCampaignPayload }>(),
        'Upsert Dealer Campaign Success': props<{ campaign: ApiTypes.DealerCampaignEditDetail }>(),
        'Upsert Dealer Campaign Failure': props<{ error: string }>(),

        'Delete Dealer Campaign': props<{ campaignId: number }>(),
        'Delete Dealer Campaign Success': emptyProps(),
        'Delete Dealer Campaign Failure': props<{ error: string }>(),

        'Load Text List Bullets': props<{ identifier: Identifiers }>(),
        'Load Text List Bullets Success': props<{ bullets: ApiTypes.EditTextListBullet[] }>(),
        'Load Text List Bullets Failure': props<{ error: string }>(),

        'Load Service List': props<{ identifier: Identifiers }>(),
        'Load Service List Success': props<{ services: ApiTypes.EditContentList[] }>(),
        'Load Service List Failure': props<{ error: string }>(),

        'Load Home Teaser List': props<{ identifier: Identifiers }>(),
        'Load Home Teaser List Success': props<{ teasers: ApiTypes.HomeTeaserList[] }>(),
        'Load Home Teaser List Failure': props<{ error: string }>(),

        'Save Text List': props<{ identifier: Identifiers; value: ApiTypes.EditTextListPayload }>(),
        'Save Text List Success': emptyProps(),
        'Save Text List Failure': props<{ error: string }>(),

        'Save Image Text Content': props<{ identifier: Identifiers; value: ApiTypes.ImageTextContent }>(),
        'Save Image Text Content Success': emptyProps(),
        'Save Image Text Content Failure': props<{ error: string }>(),
    },
});
